module.exports = __webpack_public_path__ + "img/onlineExpo_products.07c1cc71.png";